class interfaces {
    constructor() { }

    AddResources = "Add Resources";
    AddCompany = "Add Company"
    LoggedInResources = "Logged In Resources"
    ViewAllResources = "View All Resources"
    AddNewLanguage = "Add New Language"
    AddCompanyLanguage = "Add Company Language"
    TrainingScreen = "Training Screen"
    AssignUsersToTrainer = "Assign Users To Trainer"
    ChatTranscriptsWithQC = "Chat Transcripts With QC";
    TrainingScreenLite = "Training Screen Lite";
    TakeOverWithSpace = "Take Over ";
    TakeOver = "Take Over";
    TakeOverLite = "Take Over Lite"
    QAScreen = "QA Screen";
    ClientTakeover = "Client TakeOver";
    ShowContactDetails = "Show Contact Details"
    OperatorWindow = "Operator Window"
    HybridPanel = "Hybrid Panel"
    MonitoringPanel = "Monitoring Panel"
    cannedResponses = "Canned Messages"
    personalCanned = "Personal Canned Messages"
    pushContent = "Push Pages"

}
var Interfaces = new interfaces();
export { Interfaces };
